import React from 'react';
import GovLetterPage, { fleetCarRows } from './GovLetterPage';

const PAGE = {
    storageKey: 'YELO_FREE_DOC_DATA',
    title: 'Free Document (رسالة حرة)',
    detailsTitle: 'Document Details',
    form: {
        title: 'Document Title (العنوان)',
        toAddress: 'السادة هيئة الطرق والمواصلات                المحترمين',
        toCity: 'دبي -الامارات العربية المتحدة',
        introStatic1: 'نحيط سيادتكم علما نحن شركة الوفاق السعودية لتأجير السيارات ذ م م رخصة تجارية رقم 559385 بصفتنا مالكين المركبة بأنه لا مانع لدينا من',
        customAction: '',
        introPerson: '',
        introStatic2: 'للمركبة المدرج أوصافها أدناه:'
    },
    fields: [
        { key: 'date', label: 'Date', rtl: false },
        { key: 'title', label: 'Document Title (العنوان)' },
        { key: 'customAction', label: 'Custom Action (الموضوع)', full: true, rows: 2, placeholder: '[مثال: تركيب ملصق اعلاني]' },
        { key: 'introPerson', label: 'Details (Person/Entity)', full: true, rows: 2, placeholder: '[ادخل اسم الشخص أو الجهة هنا]' },
    ],
    pdfName: 'Free_Document_',
    pageId: 'free-doc-page-',
    numbered: true,
    letter: {
        intro: (f) => <>{f.introStatic1} {f.customAction} لصالح {f.introPerson} {f.introStatic2}</>,
        rows: fleetCarRows,
    },
};

const FreeDocument = (props) => <GovLetterPage page={PAGE} {...props} />;

export default FreeDocument;
